import React, { Component } from 'react';
import ReactModal from 'react-modal';

import InputErrors from '../../common/InputErrors';

class SimultaneousEditingModal extends Component {
  constructor(props) {
    super(props);
    this.state = { serverErrors: [] };
  }

  overwrite = (e) => {
    const { currentAssessment, forcePutAssessment } = this.props;
    e.preventDefault();
    this.resetErrors();
    forcePutAssessment(currentAssessment, this.onForceSuccess, this.onFail);
  }

  split = (e) => {
    const { currentAssessment, splitPutAssessment } = this.props;
    e.preventDefault();
    this.resetErrors();
    splitPutAssessment(currentAssessment, this.onSplitSuccess, this.onFail);
  }

  onForceSuccess = () => {
    const { toggleModal } = this.props;
    toggleModal();
  }

  onSplitSuccess = (response) => {
    const { history, currentQuestionIndex, toggleModal } = this.props;
    console.log(response);
    toggleModal();
    // Update the address bar with the new assessment id
    history.replace(`/assessments/${response.id}/${currentQuestionIndex}`);
  }

  onFail = (error) => {
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  resetErrors = () => {
    this.setState({ serverErrors: [] });
  }

  render() {
    const { serverErrors } = this.state;
    const { visible, lastEditedBy } = this.props;
    const editorName = lastEditedBy
      ? `${lastEditedBy.firstName} ${lastEditedBy.firstName}`
      : 'Another person in your organization';

    return (
      <ReactModal
        isOpen={visible}
        className="modal modal--centered"
        overlayClassName="modal__overlay"
      >
        <div className="modal__scroll">
          <div className="text">
            <h2>
              Someone Else Recently Edited This&nbsp;Assessment
            </h2>
            <p>
              {`${editorName} `}
              has updated this assessment within the past hour. Continuing to edit may overwrite their latest responses.
            </p>
            <p>
              Would you like to continue anyway or copy all responses from the current assessment to a new&nbsp;one?
            </p>
          </div>
          <form className="form form--modal">
            {serverErrors.length !== 0 && <InputErrors errors={serverErrors} />}
            <div className="form__submit-button-wrapper">
              <button
                type="button"
                onClick={this.split}
                className="button"
              >
                Copy Responses
              </button>
              <button
                type="submit"
                onClick={this.overwrite}
                className="button button--brand"
              >
                Continue Editing
              </button>
            </div>
          </form>
        </div>
      </ReactModal>

    );
  }
}

export default SimultaneousEditingModal;



// WEBPACK FOOTER //
// ./src/components/features/assessment/SimultaneousEditingModal.js